import contractABI from '../abi/minter_abi.json'
import Web3 from 'web3'

const contractAddress = process.env.REACT_APP_CONTRACT_ADDRESS
export const web3 = new Web3(window.ethereum);

export const simpleContract = new web3.eth.Contract(
    contractABI,
    contractAddress
)